import axios from '@/api/config';

const projectPhase = {
  getProjectPhaseById(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhase/getProjectPhaseById/` + data, {});
  },
  getProjectPhaseDetail(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhase/getProjectPhaseDetail`, {params: data});
  },
  getProjectPhase(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhase/getProjectPhase`, {params: data});
  },
  getProjectPhaseList(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhase/getProjectPhaseList`, {params: data});
  },
  getProjectPhaseTree(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhase/getProjectPhaseTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhase/pageList`, data);
  },
  addProjectPhase(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhase/addProjectPhase`, data);
  },
  updateProjectPhase(data) {
    return axios.put(`${process.env.BASE_URL}/projectPhase/updateProjectPhase`, data);
  },
  deleteProjectPhase(data) {
    return axios.delete(`${process.env.BASE_URL}/projectPhase/deleteProjectPhase`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhase/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhase/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhase/active`, data);
  },
}

export default projectPhase;



// WEBPACK FOOTER //
// ./src/api/projectPhase.js